/**
 * zeluslugi.ru
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

export function calcRound(value) {
    return Math.floor(value);
}
